'use strict';

var Marionette = require('backbone.marionette');
var Backbone = require('backbone');

var CategoryView = require('./category-list-item').default;

export default Marionette.CollectionView.extend({

  tagName: 'ul',
  className: 'category-list',
  childView: CategoryView,

  initialize: function (options) {
    this.appointment = options.appointment;
    this.services = options.services;
    this.collection = this.filterByCategory();

    this.listenTo(this.services, 'reset sync', this.onServicesReset);
    this.listenTo(this, 'childview:click:title', this.onChildViewClickTitle);
  },

  filterByCategory: function () {
    if (!window.CATEGORY) {
      return this.services.getCategories();
    }

    var filter = this.services.getCategories().filter(function (category) {
      if(category.id == window.CATEGORY.id) {
        return true;
      }
      return false;
    });

    return new Backbone.Collection(filter);
  },

  isEmpty: function (collection) {
    if (this.appointment.isPrivate()) {
      return true;
    }

    return Marionette.CollectionView.prototype.isEmpty.call(this, collection);
  },

  childViewOptions: function (model, index) {
    return {
      appointment: this.appointment,
      collection: this.services,
      defaultOpen: this.defaultOpenFirst() && index === 0,
    };
  },

  defaultOpenFirst: function () {
    return !(window.SETTINGS.collapse_categories || this.services.hasUncategorized());
  },

  onServicesReset: function () {
    this.collection = this.services.getCategories();
    this.render();
  },

  onChildViewClickTitle: function (view) {
    if (view.isCollapsable()) {
      this.children.each(function (child) {
        if (child.cid !== view.cid && child.isOpen()) {
          child.close();
        }
      });

      view.toggle();
    }
  },

  focus: function () {
    this.$el.find('.category-list-category:first-child .category-list-title').focus();
  },
});
